enum Stats {
  NumCuratedTrails = 500, // thousand
  NumUsers = 90, // million
  LoggedDistanceMeters = 2896819200000 // meters
}

export default Stats;
